import type { ActionButtonsBlock as ActionButtonsBlockType } from '../types';

export function ActionButtonsBlock({ block: _block }: { block: ActionButtonsBlockType }) {
  return null;
}

export default ActionButtonsBlock;
